"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectCaller = void 0;
const REGEXP_CALLER_ENV_TO_REMOVE = /-(staging|prod|production)$/i;
const REGEXP_CALLER_ALLOWED_CHARACTERS = /[^a-zA-Z0-9-_]/g;
class DirectCaller {
    constructor(props, problems) {
        this._rawInput = props.rawInput;
        this._caller = props.caller;
        this._version = props.version;
        this._problems = problems;
    }
    get caller() {
        return this._caller;
    }
    get version() {
        return this._version;
    }
    get problems() {
        return [...this._problems];
    }
    get rawInput() {
        return this._rawInput;
    }
    static cleanseCaller(caller) {
        const cleansedCaller = caller
            .trim()
            .replace(REGEXP_CALLER_ENV_TO_REMOVE, "")
            .replace(REGEXP_CALLER_ALLOWED_CHARACTERS, "");
        if (cleansedCaller.length === 0) {
            throw new Error("The caller must be a non-empty string");
        }
        return cleansedCaller;
    }
    static cleanseVersion(version) {
        if (version !== undefined) {
            if (version.trim().length === 0) {
                throw new Error("The version must be a non-empty string");
            }
            if (version.includes("@")) {
                throw new Error("The version must NOT contain the '@' character");
            }
            return version.trim();
        }
        return undefined;
    }
    static create(caller, version) {
        const cleansedCaller = this.cleanseCaller(caller);
        const cleansedVersion = this.cleanseVersion(version);
        return new DirectCaller({
            caller: cleansedCaller,
            version: cleansedVersion,
            rawInput: `${caller}${version ? "@" + version : ""}`,
        }, []);
    }
    static createFromString(rawInput) {
        const problems = [];
        const [afterAtSign, ...partsBeforeAtSign] = rawInput
            .split("@")
            .reverse()
            .map((part) => part.trim());
        if (partsBeforeAtSign.length > 1) {
            problems.push("Found more than one '@' in the input; the right-most one is used to extract the version");
        }
        const [extractedCaller, extractedVersion] = partsBeforeAtSign.length === 0
            ? [afterAtSign, undefined]
            :
                [partsBeforeAtSign.reverse().join(""), afterAtSign];
        const callerWithoutEnv = extractedCaller.replace(REGEXP_CALLER_ENV_TO_REMOVE, (_match, suffix) => {
            problems.push(`Removed env identifier: '-${suffix}'`);
            return "";
        });
        const cleansedCallerWithoutEnv = callerWithoutEnv.replace(REGEXP_CALLER_ALLOWED_CHARACTERS, "");
        if (cleansedCallerWithoutEnv !== callerWithoutEnv) {
            problems.push(`Removed invalid characters. Before: '${callerWithoutEnv}' - After: '${cleansedCallerWithoutEnv}'`);
        }
        return new DirectCaller({ caller: cleansedCallerWithoutEnv, version: extractedVersion, rawInput }, problems);
    }
    static createNullObject() {
        return new DirectCaller({ caller: "unknown", rawInput: "created from null object" }, []);
    }
    toString() {
        return `${this.caller}${this.version ? "@" + this.version : ""}`;
    }
}
exports.DirectCaller = DirectCaller;
//# sourceMappingURL=directCaller.js.map